import {
  LISTA_VIDEOS,
  LISTA_VIDEOS_SUCESSO,
  LISTA_VIDEOS_ERRO,
  CRIA_VIDEO,
  CRIA_VIDEO_SUCESSO,
  EDITA_VIDEO,
  EDITA_VIDEO_SUCESSO,
  DELETA_VIDEO,
  DELETA_VIDEO_SUCESSO,
  TOGGLE_ATIVO_VIDEO,
  TOGGLE_ATIVO_VIDEO_SUCESSO,
  VIDEOS_ERRO,
} from 'constants/ActionTypes';

const INIT_STATE = {
  carregando: false,
  enviando: false,
  items: [],
  total: 0,
  totalPaginas: 0,
  pagina: 1,
  tamanhoPagina: 20,
  erro: null,
  sucesso: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LISTA_VIDEOS:
      return { ...state, carregando: true, erro: null, sucesso: false };

    case LISTA_VIDEOS_SUCESSO:
      return {
        ...state,
        carregando: false,
        items: action.payload.items,
        total: action.payload.total,
        totalPaginas: action.payload.totalPaginas,
        pagina: action.payload.pagina,
        tamanhoPagina: action.payload.tamanhoPagina,
      };

    case LISTA_VIDEOS_ERRO:
      return { ...state, carregando: false, erro: action.payload };

    case CRIA_VIDEO:
    case EDITA_VIDEO:
    case DELETA_VIDEO:
    case TOGGLE_ATIVO_VIDEO:
      return { ...state, enviando: true, erro: null, sucesso: false };

    case CRIA_VIDEO_SUCESSO:
    case EDITA_VIDEO_SUCESSO:
    case DELETA_VIDEO_SUCESSO:
    case TOGGLE_ATIVO_VIDEO_SUCESSO:
      return { ...state, enviando: false, sucesso: true };

    case VIDEOS_ERRO:
      return { ...state, enviando: false, carregando: false, erro: action.payload };

    default:
      return state;
  }
};
